module.exports = __webpack_public_path__ + "static/media/sql.0acb92a2.svg";